<mat-card class="mb-2">
  <h5>{{ 'TENDER.WIZARD.RATING.TITLE.ITEM_ATTRIBUTE_TREE' | translate }}</h5>

  <mat-form-field class="w-100 search" subscriptSizing="dynamic">
    <mat-label>{{ 'TENDER.WIZARD.ITEM.LABEL.SEARCH_ITEM' | translate }}</mat-label>
    <mat-icon matIconPrefix>search</mat-icon>
    <input matInput type="search" [(ngModel)]="searchValue" autocomplete="off" id="item-search" />
  </mat-form-field>

  @for (item of filteredTreeObjects(); track item) {
    <div class="tree-container mb-3">
      <mat-accordion>
        <mat-expansion-panel class="item-expansion-panel">
          <mat-expansion-panel-header>
            <mat-panel-title> {{ item.description }} <app-item-amount [itemAmountModel]="item"></app-item-amount> </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-tree [dataSource]="item.dataSource" [treeControl]="item.treeControl">
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
              <mat-checkbox
                (change)="onSelect(item.oid!, node.oid, $event.checked)"
                [checked]="selectedAttributeOids[item.oid!] && selectedAttributeOids[item.oid!].includes(node.oid)"
                [disabled]="getDisabled(item.oid!, node.oid)"
              >
                {{ node.name }}
              </mat-checkbox>

              @if (node.scoreMax) {
                <div class="points-badge">{{ node.scoreMax }} {{ 'SHARED.POINTS' | translate }}</div>
              }
            </mat-tree-node>
          </mat-tree>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  }
</mat-card>
